import React, { useEffect, useState } from "react";

export function GreeceTermsEnglishBody() {
  const [html, setHtml] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const base = process.env.PUBLIC_URL || "";
    fetch(`${base}/greece-terms-en.html`)
      .then((res) => {
        if (!res.ok) throw new Error("not ok");
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setHtml(text);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) {
    return <p className="fs-4">Unable to load terms. Please try again later.</p>;
  }
  if (!html) {
    return <p className="fs-4 text-muted">Loading…</p>;
  }

  return (
    <div
      className="greece-terms-en-html"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
